// Forbidden route
export const FORBIDDEN_ROUTE = {
  path: '/forbidden',
  name: 'forbidden',
  component: () => import('@/views/errors/ForbiddenView.vue')
};

export const FORBIDDEN_SPACES_ROUTE = {
  path: '/forbidden-spaces',
  name: 'forbidden-spaces',
  component: () => import('@/views/errors/ForbiddenSpacesView.vue')
};

// Not found route
export const NOTFOUND_ROUTE = {
  path: '/not-found',
  name: 'notfound',
  component: () => import('@/views/errors/NotFoundView.vue')
};
